/**
 * Created by staffanrantzow on 10/11/16.
 */

import React, { PropTypes } from 'react';
import SupplierLedgerTypePickerContainer from '../supplier-ledger-type-picker-container';
import SupplierLedgerFileUpload from './supplier-ledger-file-upload';
import { proxyCounterpart } from '../../../../../scripts/proxyCounterpart';
import Translate from 'react-translate-component';
import { InputField, SpinnerButton, GeneralError } from 'components';
import { TaxService, SupplierLedgerService, Utils } from 'frilans-finans';
import { toMoney } from '../../../amount/amount-helper';
import { reformatInputValue } from '../../../invoice-tool-helper';

class SupplierLedgerForm extends React.Component {

  static propTypes = {
    invoice: PropTypes.object.isRequired,
    setSupplierLedger: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired
  };

  static contextTypes = {
    user: PropTypes.object.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      formValues: {
        supplierName: {},
        amount: {}
      },
      type: null,
      typeId: null,
      typeValid: false,
      exclVat: '',
      taxes: null,
      taxPercent: null,
      file: null,
      fileConfirmation: false,
      fileValid: true,
      showErrorWithoutBlur: false,
      showErrorForTaxType: false,
      posting: false,
      postError: false,
      imageSrc: false
    };

    this.setType = this.setType.bind(this);
    this.clearValues = this.clearValues.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.callback = this.callback.bind(this);
    this.onKeyUp = this.amountOnKeyUp.bind(this);
    this.setFile = this.setFile.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
    this.sumbitSupplierLedgerFile = this.sumbitSupplierLedgerFile.bind(this);
    this.checkboxClick = this.checkboxClick.bind(this);
  }

  amountOnKeyUp (event) {
    let amountValue = event.target.value;

    event.target.value = reformatInputValue(amountValue);
  }

  callback (name, values) {
    var tempFormValues = this.state.formValues;
    Object.assign(tempFormValues[name], values);
    this.setState({formValues: tempFormValues}, this.updateExclVat);
  }

  clearValues (e) {
    if (e) {
      e.preventDefault;
    }

    this.setState({
      showErrorWithoutBlur: false,
      showErrorForTaxType: false,
      formValues: {
        supplierName: {
          value: '',
          valid: false
        },
        amount: {
          value: '',
          valid: false
        }
      },
      exclVat: '',
      typeId: 'default',
      file: null,
      fileConfirmation: false,
      fileValid: true,
      imageSrc: false
    });
  }

  setType (type) {
    if (this.state.taxes) {
      this.setTypeAndTax(type, this.state.taxes);
    } else {
      TaxService.get()
        .then((response) => {
          this.setState({
            taxes: response
          }, () => {
            this.setTypeAndTax(type, this.state.taxes);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  /**
   * Set typeId and find the tax percent
   */
  setTypeAndTax (type, taxes) {
    let taxPercent = null;

    for (let tax of taxes) {
      if (parseInt(tax.id) === parseInt(type.taxId)) {
        taxPercent = tax.percent;
        break;
      }
    }
    if (type) {
      this.setState({
        type: type,
        taxPercent: taxPercent,
        typeValid: true,
        typeId: type.id,
        showErrorForTaxType: false
      }, this.updateExclVat);
      return;
    }
    this.setState({
      type: type,
      showErrorForTaxType: true
    });
  }

  setFile (file) {
    this.setState({file, imageSrc: file.preview});
  }

  deleteFile () {
    this.setState({file: null, imageSrc: false, fileValid: true});
  }

  sumbitSupplierLedgerFile (file, supplierLedgerId) {
    let reader = new FileReader();
    let self = this;

    reader.onload = function (e) {
      SupplierLedgerService.postFile({
        file: e.target.result,
        user_id: self.context.user.id
      }, supplierLedgerId);
    };

    reader.readAsDataURL(this.state.file);
  }

  /**
   * Calculate and set the excluding vat value
   */
  updateExclVat () {
    if (this.state.formValues.amount.value && this.state.taxPercent!=null) {
      let val = parseFloat(this.state.formValues.amount.value);
      let exclVat = (100*val)/(100+this.state.taxPercent);
      this.setState({
        exclVat: toMoney(exclVat)
      });
    }
  }

  validate () {
    // Validate amount and supplier name
    let inputFormValuesValid = Utils.validateInputValues(this.state.formValues);
    let typeValid = false;

    // Validate type (category)
    if (!this.state.type) {
      this.setState({
        showErrorForTaxType: true
      });
    }
    if (this.state.type && this.state.type.hasOwnProperty('id')) {
      typeValid = true;
    }

    this.setState({
      typeValid: typeValid
    });

    let fileValid = this.state.file ? this.state.fileConfirmation : true;

    this.setState({
      fileValid: fileValid
    });

    return inputFormValuesValid && typeValid && fileValid;
  }

  onSubmit (e) {
    e.preventDefault();

    this.setState({
      showErrorWithoutBlur: true
    }, () => {
      if (this.validate()) {
        let params = Utils.getPostParams(this.state.formValues);

        params.supplierLedgerTypeId = this.state.type.id;
        params.taxId = this.state.type.taxId;

        this.setState({
          posting: true
        });

        SupplierLedgerService.post(params, this.context.user.id)
          .then((response) => {
            let arr = (this.props.invoice.supplierLedger)
              ? this.props.invoice.supplierLedger.slice(0)
              : [];

            if (this.state.file) {
              this.sumbitSupplierLedgerFile(this.state.file, response.id);
            }

            arr.push(response);
            response.file = this.state.file;
            this.props.setSupplierLedger(arr);
            this.clearValues();

            this.setState({
              posting: false,
              postError: false,
              type: null
            });
          })
          .catch(() => {
            this.setState({
              postError: true,
              posting: false
            });
          });
      }
    });
  }

  renderError () {
    if (this.state.postError) {
      return (
        <div className="row">
          <div className="col-sm-12 post-error">
            <GeneralError/>
          </div>
        </div>
      );
    }
  }

  checkboxClick () {
    this.setState({
      fileConfirmation: !this.state.fileConfirmation
    });
  }

  renderFileConfirmationCheckbox () {
    if (this.state.file) {
      return (
        <div className="row">
          <div className="col-sm-12">
            <input id='file-confirmation' type='checkbox' name='file-confirmation' onChange={this.onChange}
              checked={this.state.fileConfirmation} onClick={this.checkboxClick} />
            <label htmlFor='file-confirmation' className='small-label'>
              <span></span><Translate content='DEDUCTION_FILE_CONFIRMATION'/>
            </label>
          </div>
        </div>
      );
    }
  }

  renderFileConfirmationError () {
    if (this.state.showErrorWithoutBlur && !this.state.fileValid) {
      return (<p className="error deduction-file-confirmation-error">
        <Translate content='DEDUCTION_FILE_CONFIRMATION_ERROR'/>
      </p>);
    }
  }

  render () {
    return (
      <form noValidate>
        <div className="row">
          <div className="col-sm-6">
            <SupplierLedgerTypePickerContainer
              setType={this.setType}
              typeId={this.state.typeId}
              showErrorWithoutBlur={this.state.showErrorForTaxType}
              errorMessage={proxyCounterpart('DEDUCTION_CATEGORY_ERROR')}
              />
          </div>
          <div className="col-sm-6">
            <InputField type='text' name='supplierName' value={this.state.formValues.supplierName.value}
              placeholder={proxyCounterpart('SUPPLIER')} callback={this.callback}
              required='true' minLength='2' errorMessage={proxyCounterpart('SUPPLIER_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
          </div>
        </div>
        <div className="row">
          <div className='col-sm-6'>
            <InputField type='text' name='amount' validationType='decimal' value={this.state.formValues.amount.value}
              placeholder={proxyCounterpart('INC_VAT')} callback={this.callback}
              onKeyUp={this.amountOnKeyUp}
              required='true' minLength='1' errorMessage={proxyCounterpart('VALUE_ERROR')}
              showErrorWithoutBlur={this.state.showErrorWithoutBlur}
              ref='amount-holder'/>
          </div>
          <div className='col-sm-6'>
            <div className="input-wrapper">
              <input disabled type="text" value={this.state.exclVat} name='exclVat' required minLength="1"/>
              <label
                htmlFor='exclVat'
                placeholder={proxyCounterpart('EXCL_VAT')}
                alt={proxyCounterpart('EXCL_VAT')}></label>
            </div>
          </div>
        </div>
        <div className="row">
          <SupplierLedgerFileUpload set={this.setFile} delete={this.deleteFile} imageSrc={this.state.imageSrc} />
        </div>
        {this.renderFileConfirmationCheckbox()}
        {this.renderFileConfirmationError()}
        <div className="row">
          <div className="col-xs-6">

          </div>
          <div onClick={this.onSubmit} className="col-xs-6 right-btn-wrapper">
            <SpinnerButton text={proxyCounterpart('ADD')}
              loading={this.state.posting} classes='btn'/>
          </div>
        </div>
        {this.renderError()}
      </form>
    );
  }

}

export default SupplierLedgerForm;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/supplier-ledger/form/supplier-ledger-form.js
 **/